import { InjectionToken, Provider, Type } from '@angular/core';
import { RosterContent } from '@softapps/pms/roster';

export type { EventDetails } from '@softapps/core/events';

export interface RosterEventProviderContext {
  /** ISO-UTC date-time of the visible period start, e.g. `2026-08-01T00:00:00.000Z` */
  from: string;
  /** ISO-UTC date-time of the visible period end */
  to: string;
  employee: { id: number | string; upn?: string };
  /** Aborted when the visible window changes; in-flight results are discarded. */
  abortSignal?: AbortSignal;
}

export interface RosterEventProvider {
  /** Stable key, used as prefix for synthesized event ids. */
  readonly key: string;
  loadEvents(context: RosterEventProviderContext): Promise<RosterContent[]>;
}

export const SOFTLINE_TOKEN_ROSTER_EVENT_PROVIDER = new InjectionToken<
  readonly RosterEventProvider[]
>('SOFTLINE_TOKEN_ROSTER_EVENT_PROVIDER');

export function provideRosterEventProvider(
  useClass: Type<RosterEventProvider>
): Provider {
  return { provide: SOFTLINE_TOKEN_ROSTER_EVENT_PROVIDER, multi: true, useClass };
}
